import { IconContentGridStandard } from "../../../../modules/icon-content-grid/components/IconContentGridStandard/IconContentGridStandard";
import type { IIconContentGridBlockProps } from "./IconContentGridBlock.props";

export const IconContentGridBlock = (props: IIconContentGridBlockProps) => {
  if (!props.items?.length) {
    return null;
  }

  return <IconContentGridStandard {...props} />;
};

IconContentGridBlock.displayName = "Block::IconContentGridBlock";
